import React from "react";
import { Gamepad2, Rocket, Wrench } from "lucide-react";
import Section from "@/theme/Section";
import { useContent } from "@/lib/content";

const ICON_MAP = {
  gamepad: Gamepad2,
  rocket: Rocket,
  wrench: Wrench,
};
const ACCENTS = ["#c8ff2a", "#ff2a8f", "#2ad6ff"];

const Services = () => {
  const { siteContent } = useContent();
  const s = siteContent.services || {};
  return (
    <Section
      id="services"
      testid="services-section"
      eyebrow={s.label || "What we do"}
      eyebrowColor="#2ad6ff"
      title={s.title}
      subtitle={s.subtitle}
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {(s.items || []).map((it, i) => {
          const Icon = ICON_MAP[it.icon] || Gamepad2;
          const accent = ACCENTS[i % ACCENTS.length];
          return (
            <article
              key={i}
              data-testid={`service-card-${i}`}
              className="group p-7 md:p-8 transition-all hover:-translate-y-1"
              style={{
                background: "rgba(13,13,13,0.7)",
                border: "1px solid rgba(255,255,255,0.12)",
                backdropFilter: "blur(14px)",
                borderRadius: "24px",
              }}
            >
              <div
                className="w-14 h-14 rounded-2xl flex items-center justify-center mb-6 transition-transform group-hover:rotate-6"
                style={{
                  background: accent,
                  color: "#060606",
                  boxShadow: `0 8px 20px -6px ${accent}80`,
                }}
              >
                <Icon size={26} strokeWidth={2.4} />
              </div>
              <h3
                className="font-black uppercase text-xl md:text-2xl"
                style={{
                  fontFamily: "'Azeret Mono', monospace",
                  letterSpacing: "-0.04em",
                  color: "#fff",
                }}
              >
                {it.title}
              </h3>
              <p
                className="mt-3 text-[15px] leading-relaxed"
                style={{ color: "rgba(255,255,255,0.65)" }}
              >
                {it.desc}
              </p>
              <div
                className="mt-6 text-[10px] tracking-[0.32em] uppercase font-bold"
                style={{ color: accent }}
              >
                / 0{i + 1}
              </div>
            </article>
          );
        })}
      </div>
    </Section>
  );
};

export default Services;
